import styled from "@emotion/styled";
import theme from "@theme/";

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.3;
  font-family: "Charlie Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    flex: 1;
    font-size: 13px;
  }
`;

const Astrik = styled.span`
  color: #ef4444;
  margin-left: 2px;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 20px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 16px;
  }
`;

const Children = styled.div`
  flex: 2;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 8px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const ReportContainer = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 20px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    padding: 24px;
    margin: 15px;
    width: calc(100% - 30px);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0 0 0;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin: 16px 0 0 0;
  }
`;

const StyledButton = styled.button`
  background: ${theme.gradient.themeGradient};
  min-width: 200px;
  height: 48px;
  border-radius: 12px;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: white;
  border: none;
  box-shadow: 0 4px 15px rgba(227, 110, 0, 0.3);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;

  &:hover {
    background: ${theme.gradient.themeGradient};
    box-shadow: 0 8px 25px rgba(227, 110, 0, 0.4);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: rgba(156, 163, 175, 0.5);
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
    font-size: 13px;
    height: 44px;
  }
`;

const SC = {
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  ReportContainer,
  ButtonContainer,
  StyledButton,
};

export default SC;
